import React, { useEffect, useState, useMemo } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import { Autoplay } from 'swiper/modules';
import AOS from 'aos';
import 'aos/dist/aos.css';

import HeadingSep from "../../assets/images/banner/heading-sep.png";
import CardsSection from "./CardsSection";
import Image from "../Contact/Image";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Service, { getImageUrl } from "../../Service/Service";


const CategorySection = ({ data, packages }) => {
  const [rating, setRating] = useState(3);
  const [searchParams, setSearchParams] = useSearchParams();

  const navigate = useNavigate()

  console.log(window.location);

  useEffect(() => {

    const token = searchParams.get('package')
    console.log(token)//123

  }, [window.location])

  // Collect all available images from the package
  const packageImages = useMemo(() => {
    const images = [];
    
    // Collect Makkah images (img1-10)
    for (let i = 1; i <= 10; i++) {
      const imgKey = `makkah_img${i}`;
      const imgValue = data[imgKey];
      if (imgValue && typeof imgValue === 'string' && imgValue.trim() !== '') {
        images.push(imgValue);
      }
    }
    
    // Collect Madina images (img1-10)
    for (let i = 1; i <= 10; i++) {
      const imgKey = `madina_img${i}`;
      const imgValue = data[imgKey];
      if (imgValue && typeof imgValue === 'string' && imgValue.trim() !== '') {
        images.push(imgValue);
      }
    }
    
    // Remove duplicates
    return [...new Set(images)];
  }, [data]);

  // If no images found, use makkah_img1 as fallback
  const displayImages = packageImages.length > 0 ? packageImages : (data.makkah_img1 ? [data.makkah_img1] : []);

  return (


    <div 
      className='flex flex-col justify-center shadow-md rounded-lg overflow-hidden select-none'
      style={{
        WebkitTouchCallout: 'none',
        WebkitTapHighlightColor: 'transparent',
        userSelect: 'none',
        touchAction: 'manipulation'
      }}
    >
      {displayImages.length > 0 ? (
        <div className="relative w-full h-48 md:h-64 overflow-hidden rounded-t-lg">
          <Swiper
            spaceBetween={0}
            slidesPerView={1}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            modules={[Autoplay]}
            className="h-full w-full"
          >
            {displayImages.map((img, index) => (
              <SwiperSlide key={index}>
                <img 
                  src={getImageUrl(img)} 
                  alt={`${data.name} - Image ${index + 1}`}
                  className="w-full h-full object-cover"
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      ) : (
        <div className="w-full h-48 md:h-64 bg-gray-200 flex items-center justify-center rounded-t-lg">
          <p className="text-gray-400 text-sm">No image</p>
        </div>
      )}

      <button 
        className="m-1 px-10 py-5 bg-secondary text-white font-bold rounded-lg flex flex-col items-center justify-center gap-2 shadow-lg overflow-hidden cursor-pointer select-none"
        onClick={() => {
          // Navigate to package detail page (works for both regular and Umrah packages)
          navigate(`/packagedetail?package=${data.uid}`)
        }}
        style={{
          WebkitTouchCallout: 'none',
          WebkitTapHighlightColor: 'transparent',
          userSelect: 'none',
          touchAction: 'manipulation'
        }}
      >
        {data.name}
      </button>




    </div>

  )
}






export default CategorySection